module.exports = __webpack_public_path__ + "static/media/mt-icone-encart-2.acd47b83.svg";